const MAX_ORDER_PREVIEW_URL_LENGTH = 750;

/**
 * Use the legacy cover thumbnail, or its template-image fallback, for order history.
 * Saved F/I delivery assets may be signed and must not be shortened or modified here.
 */
export const getEcardOrderPreviewUrl = (coverPreviewUrl: string, templatePreviewUrl?: string): string => {
  for (const candidate of [coverPreviewUrl, templatePreviewUrl]) {
    if (!candidate || candidate.length > MAX_ORDER_PREVIEW_URL_LENGTH) continue;

    let url: URL;
    try {
      url = new URL(candidate);
    } catch {
      continue;
    }
    if (url.protocol === 'https:' || url.protocol === 'http:') return candidate;
  }

  throw new Error('An HTTP(S) order preview URL of at most 750 characters is required');
};
